import { render } from "./DeleteKeyResultPrompt.vue?vue&type=template&id=3041d1e6&scoped=true"
import script from "./DeleteKeyResultPrompt.vue?vue&type=script&lang=js"
export * from "./DeleteKeyResultPrompt.vue?vue&type=script&lang=js"

import "./DeleteKeyResultPrompt.vue?vue&type=style&index=0&id=3041d1e6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3041d1e6"

export default script